import { useState } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { getAvailabilityLangEnum } from '../../../products/ProductAvailabilityRenderer';
import { useTranslation } from '../../../translation/TranslationContext';
import { CATALOG_CREATION_CRITERIA_AVAILABILITIES } from '../catalogCreationCriteria.consts';
import { CatalogCreationCriteriaSourcePickerProps } from '../catalogCreationCriteria.types';
import { filterCatalogCreationCriterionOptions } from '../catalogCreationCriteria.utils';
import CatalogCreationCriteriaValuePicker from './CatalogCreationCriteriaValuePicker';

const CatalogCreationAvailabilityCriteriaPicker = ({
  selectedIds,
  optionLabelsById,
  operator,
  onBack,
  onApply,
  onOperatorChange,
  onToggleOption,
}: CatalogCreationCriteriaSourcePickerProps) => {
  const { translate } = useTranslation();
  const [search, setSearch] = useState('');

  const availabilityLabels = getAvailabilityLangEnum(false);

  const options = CATALOG_CREATION_CRITERIA_AVAILABILITIES.map((availability) => ({
    id: availability,
    name: translate(availabilityLabels[availability]),
  }));

  const availabilityOptionLabels = Object.fromEntries(
    options.map(({ id, name }) => [id, { name }]),
  );

  return (
    <CatalogCreationCriteriaValuePicker
      title={LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_AVAILABILITY}
      search={search}
      isLoading={false}
      options={filterCatalogCreationCriterionOptions({ options, search })}
      selectedIds={selectedIds}
      optionLabelsById={{ ...optionLabelsById, ...availabilityOptionLabels }}
      operator={operator}
      onBack={onBack}
      onApply={onApply}
      onSearchChange={setSearch}
      onOperatorChange={onOperatorChange}
      onToggleOption={onToggleOption}
    />
  );
};

export default CatalogCreationAvailabilityCriteriaPicker;
